import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-48" data-mp="a5ofw4uob68">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="9mg9750515e">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="58z49v7m0e9k">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-51" data-mp="57ea46p7ixc8">
            <span aria-hidden="true" data-id="element-52" data-mp="3mfsw4zy5sj06">🏃 </span>La Differenza di RUNNING PRONTO™
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-53" data-mp="3rh8kb0vmv5ms">
            Da coach esausto a <span className="italic text-brand" data-id="element-54" data-mp="3dj0m6pmv1ya1">guida sicura di sé.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-55" data-mp="3ihv7pzc7q0xu">
            Dai alle tue lezioni un impatto visuale, ai tuoi atleti la voglia di superare i propri
            limiti e a te stesso il tempo di goderti di nuovo l&apos;insegnamento dello sport.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-56" data-mp="1f9k221qc3qs9">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-57" data-mp="1t32xxg04c1bq" data-mpi={index}>
              <dt className="sr-only" data-id="element-58" data-mp="10brr7mvqfqke">{stat.label}</dt>
              <dd data-id="element-59" data-mp="10edwffv5htzg">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-60" data-mp="wapp8yafl0eq">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-61" data-mp="1abihtdh69lf7">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-62" data-mp="2locqkv209vv1">
          <div className="grid md:grid-cols-2" data-id="element-63" data-mp="2gphuwsixwcti">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-64" data-mp="2gsxarxkftpvz">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-65" data-mp="2oqh34k4qt1sg">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-66" data-mp="2suovcraeszvf" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-67" data-mp="2xpue5h8ilyfa">
                Prima di Running Pronto
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-68" data-mp="254b1cv89kqy7">
                Il costo dell&apos;improvvisazione
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-69" data-mp="2f0eeew4nm9zx">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-70" data-mp="2jrw4gp552q64">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-71" data-mp="1mbqnajx84qeg" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-72" data-mp="1jsvn4c2227p0">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-73" data-mp="1jq9fkcf5zs6s">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-74" data-mp="19tmw9s2hl96v" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-75" data-mp="14vbkhbsmsom0">
                Con Running Pronto™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-76" data-mp="10v18nii5r3z8">
                Il sistema definitivo
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-77" data-mp="r4gb7ye805hw">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-78" data-mp="m53ln5vyskbm">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-79" data-mp="h4z2t97l3di8" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-80" data-mp="11v335wvf3ept">
            Un sistema completo per pianificare meno e allenare con più passione.
          </p>
        </div>
      </div>
    </section>;
}